import { render, staticRenderFns } from "./alarmConfiguration.vue?vue&type=template&id=5e80896e"
import script from "./alarmConfiguration.vue?vue&type=script&lang=js"
export * from "./alarmConfiguration.vue?vue&type=script&lang=js"
import style0 from "./alarmConfiguration.vue?vue&type=style&index=0&id=5e80896e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports